import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  updateStartHoles(e) {
    let pattern = e.target.value
    if (pattern && pattern.length > 0) {
      let patterns = pattern.split("_")
      document.querySelectorAll('[data-type="start-hole"]').forEach((select, i) => {
        select.value = patterns[i % patterns.length]
      })
    }
  }
}
